<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="preface" role="doc-preface">
<h1 class="h1c"><span aria-label="ix" epub:type="pagebreak" id="page_ix" role="doc-pagebreak"><strong>Preface</strong></span></h1>
<p class="noindent"><span class="dropcap">I</span> used to think conflict was due to some difficult personality or situation, but then one day I started playing with an idea: the idea that there is no conflict unless there’s an inner conflict. When you’re disturbed, angry, emotional, or impatient, when you’re thinking about what other people are doing wrong, or when you’re dredging up the past and rehashing old grudges, you’ll have conflict even when no one else is physically in the room. I asked myself the question, Could it be that the first step to effectively managing conflict is to resolve inner conflict first? To be sure, you can’t resolve inner conflict if you don’t even know you have it, so I started paying attention to how inner conflict arises and grows in my own life. I’m willing to share my challenges for the purpose of learning.</p>
<p class="indent">Inner conflict arises when I want something but I hesitate to ask for what I want, or when I’m impatient but everything around me is moving slowly. Inner conflict grows when I believe every thought without challenging my narrative, or when I assume I know someone’s motives but don’t have the courage to question their behaviors. Inner conflict deepens when I hold a grudge or continue to harbor past resentments. When I put off a conversation because I fear the other person’s defensiveness, it’s only my inner conflict keeping me from moving forward; after all, the conversation hasn’t even happened yet.</p>
<p class="indent">One of the most difficult aspects of leadership is managing conflict instead of avoiding it. My hope is that after reading this book, you will no longer avoid conflict but instead realize that conflict can be your greatest teacher and a catalyst for leadership growth.<span aria-label="x" epub:type="pagebreak" id="page_x" role="doc-pagebreak"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?4d69822b